define(['angular'], function(angular) {


    function MarginService(orderService) {
        // Gross margins on tills: array's index + 1 is tillNumber and for each tilltype margins are sorted according to the MARGIN_ORDER object below
        var MARGINS = [
            // 1 till
            {
                'BT+': [4870, 4459, 4151],
                BT: [3748, 3337, 3029]
            },
            // 2 tills
            {
                'BT+': [7947, 7288, 6796],
                BT: [6070, 5411, 4918]
            },
            // 3 tills
            {
                'BT+': [10984, 10117, 9440],
                BT: [8351, 7484, 6807]
            },
            // 4 tills
            {
                'BT+': [13410, 12377, 11554],
                BT: [10143, 9110, 8288]
            },
            // 5 tills
            {
                'BT+': [15265, 14106, 13180],
                BT: [11488, 10328, , 9403]
            }
        ];

        // software conditions in each margin array used as the sort criteria
        var MARGIN_ORDER = ['TABACPRESSE', 'PRESSE', 'TABAC'];

        self.getMargin = function getMargin(tills, softwareType) {
            var nbTills = orderService.getNbTills(tills);
            var tillType = {
                id: orderService.areTillsMixed(tills).tillType.id,
                code: orderService.areTillsMixed(tills).tillType.code,
                label: orderService.areTillsMixed(tills).tillType.label
            };
            var softIndex = -1;
            MARGIN_ORDER.forEach(function(soft, index) {
                if (soft === softwareType) {
                    softIndex = index;
                }
            });
            return MARGINS[nbTills - 1][tillType.code][softIndex];
        };

        return self;
    }

    MarginService.$inject = ['orderService'];

    angular.module('app.bdc.common.marginService', []).factory('marginService', MarginService);
});
